import {FunctionComponent, Ref} from 'react';

export type CardContentProps = {
    className?: string
    forwardedRef?: Ref<HTMLDivElement>
}

const CardContent: FunctionComponent<CardContentProps> = ({className, forwardedRef, children}) => {
    return (
        <div className={`dfb-Card-content ${className ?? ''}`} ref={forwardedRef}>
            {children}
        </div>
    );
};

export default CardContent;
